export default __webpack_public_path__ + "static/media/HelpDesk.b667efdc.svg";